var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_24634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15.5,
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1062 16.3938L11.3455 16.3938C11.1537 16.3938 10.9969 16.2381 11 16.0463C11.0008 16.0034 11.0016 15.9789 11.0024 15.9639C11.0128 15.7689 11.1592 15.608 11.3545 15.608L16.1062 15.608L16.1062 10.8473C16.1062 10.6555 16.2617 10.5 16.4535 10.5L16.5447 10.5C16.7365 10.5 16.892 10.6555 16.892 10.8473L16.892 15.608L21.6527 15.608C21.8445 15.608 22 15.7635 22 15.9553V16.0465C22 16.2383 21.8445 16.3938 21.6527 16.3938L16.892 16.3938L16.892 21.1545C16.892 21.3463 16.7363 21.5031 16.5445 21.5C16.5015 21.4992 16.477 21.4984 16.4621 21.4976C16.267 21.4872 16.1062 21.3408 16.1062 21.1455L16.1062 16.3938Z",
    fill: "#909090",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_24634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDark);
export default __webpack_public_path__ + "static/media/AddDark.5128fa37.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_24634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15.5,
    stroke: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1062 16.3938L11.3455 16.3938C11.1537 16.3938 10.9969 16.2381 11 16.0463C11.0008 16.0034 11.0016 15.9789 11.0024 15.9639C11.0128 15.7689 11.1592 15.608 11.3545 15.608L16.1062 15.608L16.1062 10.8473C16.1062 10.6555 16.2617 10.5 16.4535 10.5L16.5447 10.5C16.7365 10.5 16.892 10.6555 16.892 10.8473L16.892 15.608L21.6527 15.608C21.8445 15.608 22 15.7635 22 15.9553V16.0465C22 16.2383 21.8445 16.3938 21.6527 16.3938L16.892 16.3938L16.892 21.1545C16.892 21.3463 16.7363 21.5031 16.5445 21.5C16.5015 21.4992 16.477 21.4984 16.4621 21.4976C16.267 21.4872 16.1062 21.3408 16.1062 21.1455L16.1062 16.3938Z",
    fill: "#909090",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_24634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDark);
export default __webpack_public_path__ + "static/media/AddDark.5128fa37.svg";
export { ForwardRef as ReactComponent };